<script>
  let isHovered = false;
  let xCoord = 1;
  let yCoord = 1;

  function mouseOver(e) {
    xCoord = e.offsetX;
    yCoord = e.offsetY;
    isHovered = true;
  }
  function mouseLeave() {
    isHovered = false;
  }
</script>

<g on:mouseover={mouseOver} on:mouseleave={mouseLeave}>
  <slot {isHovered} {xCoord} {yCoord} />
</g>

<style>
</style>
